var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-07-31
 * @brief SEI 고객 문의 Management 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { loadingBoxState } from "../../../recoil/menuState";
import { reLoad, userInfoLoginState } from "../../../recoil/userState";
// utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
//component
import dayjs from "dayjs";
import EhpPagination from "../../common/pagination/EhpPagination";
//압축 다운로드
import { usePopup } from "@components/common/popup/CommonPopup";
import EconsultAnswerPop from "@components/management/popup/EconsultAnswerPop";
import { ExcelDataMapping, ExcelSheet } from "@utils/file/fileUtil";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
function EconsultMain() {
    //transe, navigate
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const reload = useRecoilValue(reLoad);
    const [consultList, setConsultList] = useState([]);
    const [malfunctionItem, setMalfunctionItem] = useState([]);
    const [listInfo, setListInfo] = useState(null);
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 문의 유형
    const [consultType, setConsultType] = useState({ code: "C01_07", codeName: "ALL", description: "전체" });
    //검색
    const searchFieldList = [
        { id: 0, sfDisp: "제목", sfVal: "subject" },
        { id: 1, sfDisp: "문의내용", sfVal: "content" },
        { id: 2, sfDisp: "답변", sfVal: "reply" },
    ];
    const [searchText, setSearchText] = useState("");
    const [searchInit, setSerarchInit] = useState(searchFieldList[0]);
    const [searchTextField, setSearchTextField] = useState({
        searchField: searchInit.sfVal,
        searchText: "",
    });
    //
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "",
        sort: "asc",
    });
    //
    let appPath = `page=${pageInfo.number}&size=${pageInfo.size}`;
    appPath = appPath + `&consultType=${consultType.codeName}`; // 문의 유형
    // 검색 필드
    if (searchTextField.searchText.length > 0) {
        appPath = appPath + `&searchKind=${searchTextField.searchField}&stringLike=${searchTextField.searchText}`;
    }
    //필드 정렬
    if (sortData.sortField) {
        appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
    }
    const { openPopup, closePopup } = usePopup();
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/board/consults?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload,
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (data) {
            setRecoilIsLoadingBox(false);
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data.codeNum == CONST.API_200) {
                setPageInfo(Object.assign({}, data.data.page /*  psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false  */)); //5, 10
                setConsultList(data.body);
            }
        }
    }, [data, reload]);
    // 상세 API 및팝업
    function AnswerPop(e, list, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/board/consult/${list.consultId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setListInfo(list);
                    openPopup(_jsx(EconsultAnswerPop, { consultInfo: data.body, closePopup: closePopup, type: type }));
                }
            }
        });
    }
    // 문의하기
    function MalfunctionSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/board/code/types`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setMalfunctionItem(data.body);
                }
            }
        });
    }
    // 문의 유형 선택 - select
    function MalfunctionClick(item) {
        setConsultType(item);
        setSortData({
            sort: "asc",
            sortField: "",
        });
        handleCurPage(0);
        if (searchInit.id > 0) {
            setSearchText("");
            setSearchTextField({
                searchText: "",
                searchField: searchFieldList[0].sfVal,
            });
            setSerarchInit(searchFieldList[0]);
        }
    }
    function SelectClick(item) {
        if (searchInit !== item) {
            setSearchText("");
            setSerarchInit(item);
        }
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        handleCurPage(0);
        setSortData({
            sort: "asc",
            sortField: "",
        });
        setSearchTextField({
            searchText: searchText,
            searchField: searchInit.sfVal,
        });
    }
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    function ListClick(list) {
        setListInfo(list);
    }
    // 엑셀 리스트
    function ListExcell(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            let items = list.itemIds.map((item) => item);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/item/series?itemIds=${items}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    excelDownloadSaved(data.body, list);
                    setListInfo(list);
                }
            }
        });
    }
    // List Download
    function excelDownloadSaved(excelData, list) {
        const excelFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"; // 파일 타입 및 유니코드
        const excelFileExtension = ".xlsx"; // 확장자 명
        const excelFileName = `문의설비_${list.requestCompanyName}_${list.requestZoneName}_${dayjs(list.requestedDate).format("YYYY-MM-DD")}`; // 파일명
        const excelSheet = ExcelSheet;
        ExcelDataMapping(excelData, excelSheet);
        // wb == workBook 약자
        const wb = { Sheets: { Sheet: excelSheet }, SheetNames: ["Sheet"] };
        const excelButter = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelButter], { type: excelFileType });
        FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
    }
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "box-wrap" }, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uACE0\uAC1D \uBB38\uC758" })) })), _jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements <= 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "tbl__top mt-19" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", { children: "\uBB38\uC758 \uC720\uD615" }) })), _jsxs("div", Object.assign({ className: "select malfunction w200", onClick: (e) => MalfunctionSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: "\uC804\uCCB4 " })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => MalfunctionClick({ code: "C01_07", codeName: "ALL", description: "전체" }) }, { children: "\uC804\uCCB4" })), malfunctionItem &&
                                                                        malfunctionItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => MalfunctionClick(list) }, { children: list.description }), "malfunction_" + idx.toString())))] })] }))] })) })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsxs("div", Object.assign({ className: "select search w108", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": searchFieldList[0].sfVal }, { children: searchInit.id <= 0 ? searchFieldList[0].sfDisp : searchInit.sfDisp })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: searchFieldList.map((sf, idx) => (_jsx("li", Object.assign({ id: "selects" + idx, onClick: (e) => SelectClick(sf), className: "option", "data-value": sf.sfVal }, { children: sf.sfDisp }), "search_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "input__direct w200" }, { children: [_jsx("input", { type: "text", placeholder: "\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694", value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: "\uAC80\uC0C9" }) }))] })) }))] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uB370\uC774\uD130\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." })), consultList && (_jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uC0C1\uC138\uC720\uD615 \uBA85,\uCD5C\uC2E0 \uBC84\uC804,\uBC84\uC804 \uC218,\uD56D\uBAA9 \uC218,\uC218\uC815 \uB0A0\uC9DC,\uBA54\uBAA8,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8  \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0C1\uC138\uC720\uD615 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "6%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "6%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "consultType" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("consultType") }, { children: _jsx("span", { children: "\uBB38\uC758 \uC720\uD615" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "subject" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("subject") }, { children: _jsx("span", { children: "\uC81C\uBAA9" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uBB38\uC758 \uC124\uBE44 " }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC694\uCCAD \uD68C\uC0AC" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC694\uCCAD \uC0AC\uC5C5\uC7A5 " }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uB2C9\uB124\uC784" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC774\uB984" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "email" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("email") }, { children: _jsx("span", { children: "E-mail(ID)" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort 
                                ${sortData.sortField === "userPhoneNo" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("userPhoneNo") }, { children: _jsx("span", { children: "\uC5F0\uB77D\uCC98" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uBB38\uC758 \uC77C\uC790" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uB2F5\uBCC0 \uC5EC\uBD80" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uB2F5\uBCC0 \uC77C\uC790" }) }))] }) }), _jsx("tbody", { children: consultList.map((list, idx) => (_jsxs("tr", Object.assign({ className: listInfo && listInfo.consultId == list.consultId ? "selected" : "", onClick: (e) => ListClick(list) }, { children: [_jsx("td", { children: list.consultType }), _jsx("td", Object.assign({ className: `${list.subject.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.subject }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.subject ? list.subject : "-" })) })), _jsx("td", { children: list.itemIds.length > 0 ? (_jsx("button", Object.assign({ type: "button", className: "btn btn-add-file", onClick: (e) => ListExcell(list) }, { children: _jsx("span", { children: list.itemIds.length }) }))) : (_jsx("span", { children: "-" })) }), _jsx("td", { children: list.requestCompanyName ? list.requestCompanyName : "-" }), _jsx("td", { children: list.requestZoneName ? list.requestZoneName : "-" }), _jsx("td", { children: list.nickName ? list.nickName : "-" }), _jsx("td", { children: list.userName }), _jsx("td", Object.assign({ className: `${list.userEmail.length > 23 ? "tooltip-link" : ""}`, "data-tooltip": list.userEmail }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.userEmail ? list.userEmail : "-" })) })), _jsx("td", { children: list.userPhoneNo ? list.userPhoneNo.toString().replace(/(\d{3})(\d{4})/, "$1-$2-") : "-" }), _jsx("td", { children: list.requestedDate ? dayjs(list.requestedDate).format("YYYY-MM-DD") : "-" }), _jsx("td", { children: !list.replyYn ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic m-0 js-open", "data-pop": "pop-answer", onClick: (e) => AnswerPop(e, list, "pop-answer") }, { children: _jsx("span", { children: "\uD655\uC778" }) }))) : (_jsx("button", Object.assign({ type: "button", className: "btn-basic m-0 js-open dis-click", "data-pop": "pop-answer-end", onClick: (e) => AnswerPop(e, list, "pop-answer-end") }, { children: _jsx("span", { children: "\uB2F5\uBCC0\uC644\uB8CC" }) }))) }), _jsx("td", { children: list.responseDate ? dayjs(list.responseDate).format("YYYY-MM-DD") : "-" })] }), "consult_" + idx.toString()))) })] })) }))), _jsx(EhpPagination, { componentName: "CONSULT", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] })) })) }));
}
export default EconsultMain;
